import React, { useState } from "react";
import { Form, Row, Col, Button  } from 'react-bootstrap';
import { signUpAdminApi } from "../../../../api/user";
import { getAccessTokenApi } from "../../../../api/auth";
import { errorModal, successModal, warningModal } from '../../../Alerts/Alerts';


export default function EditUserForm(props) {
  const { setIsVisibleModal, setReloadUsers } = props;
  const [userData, setUserData] = useState({});

  const addUser = e => {
    e.preventDefault();

    if (
        !userData.nm_login ||
        !userData.nombres ||
        !userData.apellido_paterno ||
        !userData.apellido_materno ||
        !userData.nm_correo ||
        !userData.nm_password ||
        !userData.repeatPassword
        ) {
            warningModal("Advertencia", "Todos los campos son obligatorios.");
        } else if (userData.nm_password !== userData.repeatPassword) {
            warningModal("Advertencia", "Las contraseñas tienen que ser iguales.");
        } else {
            const accessToken = getAccessTokenApi();

            signUpAdminApi(accessToken, userData)
                .then(response => {
                    setIsVisibleModal(false);
                    setReloadUsers(true);
                    if(response.code ===200){
                      setUserData({});
                      successModal("",response.message);
                    }else{
                      errorModal("Error", response.message)
                    }
                    
                })
                .catch(err => {
                    errorModal	("Error", err);
            });
        }
    };

  return (
    <div className="add-user-form">
      <AddForm
        userData={userData}
        setUserData={setUserData}
        addUser={addUser}
      />
    </div>
  );
}

function AddForm(props) {
  const { userData, setUserData, addUser } = props;

  return (
    <>
      <Form className="form-add" >
        <Row gutter={24}>
          <Col span={24}>
            <Form.Group>
              <Form.Control
                type="text"
                placeholder="Login"
                onChange={e => setUserData({ ...userData, nm_login: e.target.value })}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={24}>
            <Form.Group>
              <Form.Control
                type="text"
                placeholder="Nombres"
                onChange={e => setUserData({ ...userData, nombres: e.target.value })}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={12}>
            <Form.Group>
              <Form.Control
                type="text"
                placeholder="Apellido Paterno"
                onChange={e =>
                  setUserData({ ...userData, apellido_paterno: e.target.value })
                }
              />
            </Form.Group>
          </Col>
          <Col span={12}>
            <Form.Group>
              <Form.Control
                type="text"
                placeholder="Apellido Materno"
                onChange={e =>
                  setUserData({ ...userData, apellido_materno: e.target.value })
                }
              />
            </Form.Group>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={24}>
            <Form.Group>
              <Form.Control
                type="text"
                placeholder="Correo electrónico"
                onChange={e =>
                  setUserData({ ...userData, nm_correo: e.target.value })
                }
              />
            </Form.Group>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={12}>
            <Form.Group>
              <Form.Control
                type="password"
                placeholder="Contraseña"
                onChange={e =>
                  setUserData({ ...userData, nm_password: e.target.value })
                }
              />
            </Form.Group>
          </Col>
          <Col span={12}>
            <Form.Group>
              <Form.Control
                type="password"
                placeholder="Repetir contraseña"
                onChange={e =>
                  setUserData({ ...userData, repeatPassword: e.target.value })
                }
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group>
          <Button variant="success" onClick={addUser} style={{"width" : "100%"}}>
            Crear Usuario
          </Button>
        </Form.Group>
      </Form>
    </>
  );
}
